import Swiper from './swiper-bundle.esm.browser.min.js';
gsap.registerPlugin(ScrollTrigger);

const header = document.querySelector('#header');
const gnb = document.getElementById('gnb');
const gnbBg = document.getElementById('gnb-bg');
let deviceDetect = '';
// Event
(function () {
	var unlistenableWindowEvents = {
		click: 1,
		dblclick: 1,
		keyup: 1,
		keypress: 1,
		keydown: 1,
		mousedown: 1,
		mouseup: 1,
		mousemove: 1,
		mouseover: 1,
		mouseenter: 1,
		mouseleave: 1,
		mouseout: 1,
		storage: 1,
		storagecommit: 1,
		textinput: 1
	};

	function indexOf(array, element) {
		var
		index = -1,
		length = array.length;

		while (++index < length) {
			if (index in array && array[index] === element) {
				return index;
			}
		}

		return -1;
	}

	var existingProto = (window.Event && window.Event.prototype) || null;
	window.Event = Window.prototype.Event = function Event(type, eventInitDict) {
		if (!type) {
			throw new Error('Not enough arguments');
		}

		// Shortcut if browser supports createEvent
		if ('createEvent' in document) {
			var event = document.createEvent('Event');
			var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
			var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

			event.initEvent(type, bubbles, cancelable);

			return event;
		}

		var event = document.createEventObject();

		event.type = type;
		event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
		event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

		return event;
	};
	if (existingProto) {
		Object.defineProperty(window.Event, 'prototype', {
			configurable: false,
			enumerable: false,
			writable: true,
			value: existingProto
		});
	}

	if (!('createEvent' in document)) {
		window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
			var
			element = this,
			type = arguments[0],
			listener = arguments[1];

			if (element === window && type in unlistenableWindowEvents) {
				throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
			}

			if (!element._events) {
				element._events = {};
			}

			if (!element._events[type]) {
				element._events[type] = function (event) {
					var
					list = element._events[event.type].list,
					events = list.slice(),
					index = -1,
					length = events.length,
					eventElement;

					event.preventDefault = function preventDefault() {
						if (event.cancelable !== false) {
							event.returnValue = false;
						}
					};

					event.stopPropagation = function stopPropagation() {
						event.cancelBubble = true;
					};

					event.stopImmediatePropagation = function stopImmediatePropagation() {
						event.cancelBubble = true;
						event.cancelImmediate = true;
					};

					event.currentTarget = element;
					event.relatedTarget = event.fromElement || null;
					event.target = event.target || event.srcElement || element;
					event.timeStamp = new Date().getTime();

					if (event.clientX) {
						event.pageX = event.clientX + document.documentElement.scrollLeft;
						event.pageY = event.clientY + document.documentElement.scrollTop;
					}

					while (++index < length && !event.cancelImmediate) {
						if (index in events) {
							eventElement = events[index];

							if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') {
								eventElement.call(element, event);
							}
						}
					}
				};

				element._events[type].list = [];

				if (element.attachEvent) {
					element.attachEvent('on' + type, element._events[type]);
				}
			}

			element._events[type].list.push(listener);
		};

		window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
			var
			element = this,
			type = arguments[0],
			listener = arguments[1],
			index;

			if (element._events && element._events[type] && element._events[type].list) {
				index = indexOf(element._events[type].list, listener);

				if (index !== -1) {
					element._events[type].list.splice(index, 1);

					if (!element._events[type].list.length) {
						if (element.detachEvent) {
							element.detachEvent('on' + type, element._events[type]);
						}
						delete element._events[type];
					}
				}
			}
		};

		window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
			if (!arguments.length) {
				throw new Error('Not enough arguments');
			}

			if (!event || typeof event.type !== 'string') {
				throw new Error('DOM Events Exception 0');
			}

			var element = this, type = event.type;

			try {
				if (!event.bubbles) {
					event.cancelBubble = true;

					var cancelBubbleEvent = function (event) {
						event.cancelBubble = true;

						(element || window).detachEvent('on' + type, cancelBubbleEvent);
					};

					this.attachEvent('on' + type, cancelBubbleEvent);
				}

				this.fireEvent('on' + type, event);
			} catch (error) {
				event.target = element;

				do {
					event.currentTarget = element;

					if ('_events' in element && typeof element._events[type] === 'function') {
						element._events[type].call(element, event);
					}

					if (typeof element['on' + type] === 'function') {
						element['on' + type].call(element, event);
					}

					element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
				} while (element && !event.cancelBubble);
			}

			return true;
		};

		// Add the DOMContentLoaded Event
		document.attachEvent('onreadystatechange', function() {
			if (document.readyState === 'complete') {
				document.dispatchEvent(new Event('DOMContentLoaded', {
					bubbles: true
				}));
			}
		});
	}
}());
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {
  var throttle = function(type, name, obj) {
      obj = obj || window;
      var running = false;
      var func = function() {
          if (running) { return; }
          running = true;
           requestAnimationFrame(function() {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
          });
      };
      obj.addEventListener(type, func);
  };

  /* init - you can init any event */
  throttle("resize", "optimizedResize");
})();

// handle event
window.addEventListener("optimizedResize", function() {
  let intViewportWidth = window.innerWidth;
  if(intViewportWidth < 992){
    //mobile
    deviceDetect = 'mobile';
    header.classList.remove('on');
    document.body.classList.remove('on');
  } else{
    //pc
    deviceDetect = 'pc';
  }
  
});

window.dispatchEvent(new Event('optimizedResize'));

let last_known_scroll_position = 0;
let ticking = false;

function scrollControll(scroll_pos) {
  // scroll 위치에 대한 작업을 하세요
  if(last_known_scroll_position >= 85 && deviceDetect === 'pc'){
    header.classList.add('on');
    document.body.classList.add('on')
  } else {
    header.classList.remove('on');
    document.body.classList.remove('on');
  }
}

window.addEventListener('scroll', function(e) {
  last_known_scroll_position = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(function() {
      scrollControll(last_known_scroll_position);
      ticking = false;
    });

    ticking = true;
  }
});

let hamBtn = document.querySelector('.menu-btn');
let clsBtn = document.querySelector('.close-btn');
let bgBtn = document.querySelector('#nav-bg');
let clickEvent = (function() {
  if ('ontouchstart' in document.documentElement === true) {
    return 'touchstart';
  } else {
    return 'click';
  }
})();

hamBtn.addEventListener(clickEvent,function(){
  // ...
  document.querySelector('.mobile-nav').classList.add('show-nav');
  hamBtn.classList.add('active');
  bgBtn.classList.add('show-nav');
});

clsBtn.addEventListener(clickEvent,function(){
  // ...
  document.querySelector('.mobile-nav').classList.remove('show-nav');
  hamBtn.classList.remove('active');
  bgBtn.classList.remove('show-nav');
});

bgBtn.addEventListener(clickEvent,function(){
  // ...
  document.querySelector('.mobile-nav').classList.remove('show-nav');
  hamBtn.classList.remove('active');
  bgBtn.classList.remove('show-nav');
});

let menuItem = document.querySelectorAll('#m-menu > li');

menuItem.forEach(menu =>{menu.addEventListener(clickEvent,function(e){
  this.tg = e.target;
  this.menuList = this.tg.parentNode;

  if(this.tg.nextElementSibling.classList.contains('m-depth2')) {
    e.preventDefault();
    if(this.menuList.classList.contains('active')){
      //클릭한 메뉴에 active가 있을때
      removeClass(menuItem,'on');
      this.menuList.classList.remove('active');
      gsap.fromTo(this.menuList,{
          height: this.tg.offsetHeight + this.tg.nextElementSibling.offsetHeight,
        },
        {
          height: this.tg.offsetHeight,
          duration: .6
        });
    } else if(!this.menuList.classList.contains('on')){
      //내가 클릭한 메뉴에 on이 없을때 active가 없을때
      removeClass(menuItem,'on');
      this.menuList.classList.add('on');
      gsap.to(menuItem,
        {
          height: this.tg.offsetHeight,
          duration: .6,
          onStart:()=>{removeClass(menuItem,'active');}
        });
      gsap.to(this.menuList,
        {
          height: this.tg.offsetHeight + this.tg.nextElementSibling.offsetHeight,
          duration: .6
        });
    } else{
      //클릭한 메뉴에 이미 on이 있을때
      this.menuList.classList.remove('on');
      gsap.to(this.menuList,
        {
          height: this.tg.offsetHeight,
          duration: .6
        });
    }
    
  }

})})


// ** FADE OUT FUNCTION **
function fadeOut(el) {
  el.style.opacity = 1;
  (function fade() {
    if ((el.style.opacity -= .1) < 0) {
      el.style.display = "none";
    } else {
      requestAnimationFrame(fade);
    }
  })();
}

// ** FADE IN FUNCTION **
const fadeIn = (el, display) => {
  el.style.opacity = 0;
  el.style.display = display || "block";
  (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += .1) > 1)) {
          el.style.opacity = val;
          requestAnimationFrame(fade);
      }
  })();
};

const depth2 = document.getElementsByClassName('depth2');
// gnb controller
const gnbOver = (event) => {
  gnbBg.classList.add('bg-down');
  gnb.classList.add('bg-down');
  for (let i = 0; i < depth2.length; i++) {
    depth2[i].style.display = 'block';
  }
}
const gnbLeave = (event) => {
  gnbBg.classList.remove('bg-down');
  gnb.classList.remove('bg-down');
  for (let i = 0; i < depth2.length; i++) {
    depth2[i].style.display = 'none';
  }
}
gnb.addEventListener('mouseover',gnbOver);
gnb.addEventListener('mouseleave',gnbLeave);

//상단 고정 슬라이더
const mySwiper = new Swiper('.header-top__slide', {
    // Optional parameters
    loop: true,
    // Navigation arrows
    navigation: {
        nextEl: '.ctrls1.next',
        prevEl: '.ctrls1.prev',
    },
});

//메인 슬라이더
let video01Player = '';
var options01 = {
  id: 470017339,
  width: 1920,
  background:true
};

const mainReview = document.querySelector('.main-review');
const reviewBg = document.querySelector('.main-review-bg');

const mySwiper1 = new Swiper(mainReview, {
	speed: 400,
	autoplay: {
    delay: 5000,
    stopOnLastSlide: true
	},
	loop: true,
	navigation: {
    nextEl: '.ctrls2.next',
    prevEl: '.ctrls2.prev',
  },
	// pagination: {
	// 	el: '.main-pagi',
	// 	type: 'bullets',
	// 	clickable: true,
	// },
  slideDuplicateActiveClass: 'swiper-slide-active',
  on: {
    init: function () {
      video01Player = new Vimeo.Player('player1', options01);
      //document.querySelector('.review-bg-img').classList.add('ani-scale-down');
    },
  },
  // on:{
  //   reachEnd:() => {
      
  //     setTimeout(()=>{
  //       const disableBtn = document.querySelector('.ctrls2.swiper-button-disabled');
  //       hideSwiper(disableBtn);
  //     },200)
      
  //     setTimeout(()=>hideSwiper(),2500);
      
  //   }
  // }
});


const ctrls2 = document.querySelectorAll('.main-review .ctrls2');
function addClass(elem,className){
  let max = elem.length;
  for(let i=0;i<max; i++){
    elem[i].classList.add(className);
  }
}
function removeClass(elem,className){
  let max = elem.length;
  for(let i=0;i<max; i++){
    elem[i].classList.remove(className);
  }
}

// mySwiper1.on('slideNextTransitionStart', function () {
//   var idx = mySwiper1.realIndex;
//   //console.log(idx);
//   // if(idx == 2){
//   //   if(video01Player == ''){
//   //     video01Player = new Vimeo.Player('player1', options01);
//   //     video01Player.pause();
//   //   } else{
//   //     video01Player.pause();
//   //   }
//   // }
//   if(idx == 3){
//     document.querySelector('.review-bg-img').classList.add('ani-scale-down');
//     removeClass(ctrls2,'to-side');
//     fadeIn(reviewBg);
//     video01Player.pause();
//   }
//   if(idx == 0){
//     addClass(ctrls2,'to-side');
//     fadeOut(reviewBg);
//     video01Player.play();
//   }
	
// });
// mySwiper1.on('slidePrevTransitionStart', function () {
//   var idx = mySwiper1.realIndex;
//   //console.log(idx);
//   if(idx == 2){
//     addClass(ctrls2,'to-side');
//     fadeOut(reviewBg);
//   }
//   if(idx == 5){
//     document.querySelector('.review-bg-img').classList.add('ani-scale-down');
//     removeClass(ctrls2,'to-side');
//     fadeIn(reviewBg);
//     // if(video01Player == ''){
//     //   var options01 = {
//     //     id: 470017339,
//     //     width: 1920,
//     //     background:true
//     //   };
//     //   video01Player = new Vimeo.Player('player1', options01);
//     // } else{
//     //   video01Player.play();
//     // }
//   }
// });
// let reviewSwiperOption = {
//   // Optional parameters
//   loop: true,
//   autoplay: {
// 		delay: 5000,
// 	},
//   // pagination
//   pagination: {
// 		el: '.review-pagi',
// 		type: 'bullets',
// 		clickable: true,
// 	},
//   // Navigation arrows
//   navigation: {
//       nextEl: '.ctrls2.next',
//       prevEl: '.ctrls2.prev',
//   },
// }
// const reviewSwiper = new Swiper('.review-slide-box', reviewSwiperOption);
// const reviewSwiperM = new Swiper('.m-review-slide-box', reviewSwiperOption);

// function animateOnScroll(yOffset) {
//     if(yOffset > 0){
//       document.body.classList.add('scroll-start');
//     } else{
//       document.body.classList.remove('scroll-start');
//     }
// }

// window.addEventListener('scroll', function(e) {
//   yOffset = window.scrollY;

//   if (!ticking) {
//     window.requestAnimationFrame(function() {
//       animateOnScroll(yOffset);
//       ticking = false;
//     });

//     ticking = true;
//   }
// });
const waypoint = document.querySelectorAll('.waypoint');

waypoint.forEach((waypoint,index) => {
  ScrollTrigger.create({
    trigger: waypoint,
    id: index+1,
    start: 'top 60%',
    end: () => `+=${waypoint.clientHeight + 250}`,
    onEnter:()=>waypoint.classList.add('on'),
    //toggleClass: {className: 'on', targets: waypoint},
    //markers: true
  });
});


const quick = document.querySelector('.quick-btn');
let switchToggle = false;
const clickHandler = (event) => {
  let elem = event.target;
  while(!elem.classList.contains('quick-btn')){
    elem = elem.parentNode;
  }
  elem.parentNode.classList.toggle('active');
  //gsap.to(window, {duration: .4, scrollTo: 400});
  // if(!switchToggle){
  //   gsap.fromTo(".quick", {left: '100%'}, {height: 500, duration: .4});
  //   switchToggle = true;
  // } else{
  //   gsap.to(".quick", {left: 45, duration: .4});
  //   switchToggle = false;
  // }
}
quick.addEventListener('click',clickHandler);




//메인페이지 전용 스크립트
const mainVisual = document.querySelector('.main-visual');
if(mainVisual){

  //reviewSwiper.autoplay.stop();
  //clean-sect 스크롤
  var options02 = {
    id: 469600365,
    width: 1920,
    background:true
  };
  let video02Player = '';
  const reasonList = document.querySelectorAll('.reason_list li');
  // clean-sect 반응형
  ScrollTrigger.matchMedia({
    
    // desktop
    "(min-width: 800px)": function() {
      // setup animations and ScrollTriggers for screens over 800px wide (desktop) here...
      // ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
      
      // gsap.fromTo(".review-sect-bg", {
      //   scale: 1.2,
      //   opacity:0,
      // },{
      //   scrollTrigger: {
      //     trigger:".review-sect",
      //     start:'top center',
      //     end: () => `+=${waypoint.clientHeight + 30}`,
      //     onEnter: () => {reviewSwiper.autoplay.start()},
      //     toggleActions: "play none none none"
      //   },
      //   scale: 1,
      //   opacity:1,
      //   duration:2
      // });
      
      reasonList.forEach((reason,index) => {
        gsap.fromTo(reason, 
        {
          y: 50,
          opacity:0,
        },
        {
          scrollTrigger: {
            trigger:reason,
            start:'top 40%',
            end: () => `+=${reason.clientHeight}`,
            onEnter:() => {
              if(video02Player == ''){
                video02Player = new Vimeo.Player('player2', options02);
              } else{
                video02Player.pause()
              }
            },
            onEnterBack: () => {video02Player.pause()},
            onLeave:()=>{video02Player.play()},
            //markers:true
          },
          y: 0,
          opacity:1,
          duration:.6,
          ease:'ease',
          delay:`${index * .2}`
        });
      });

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".clean-sect",
          start: "-50px top",
          end: () => {
            innerHeight * 4
          },
          scrub: true,
          pin: ".clean-sect",
          anticipatePin: 1,
          onEnter: () => {video02Player.play()},
          onEnterBack: ()=>{video02Player.play()},
        }
      });
      tl.from(".pin-layer", {
        scale: 0.9,
        ease: "none",
      });
      gsap.from(".clean-sect__box", {
        scrollTrigger: {
          trigger:".clean-sect",
          start:'top center',
          toggleActions: "play none none none"
        },
        opacity: 0,
        duration: .6,
        delay:.8
      });
      gsap.from(".clean-txt01", {
        scrollTrigger: {
          trigger:".clean-sect",
          start:'top center',
          toggleActions: "play none none none"
        },
        opacity: 0,
        duration: 1,
        delay:1.4
      });
      gsap.from(".clean-txt02", {
        scrollTrigger: {
          trigger:".clean-sect",
          start:'top center',
          toggleActions: "play none none none"
        },
        opacity: 0,
        duration: 1,
        delay:2
      });
      gsap.from(".clean-txt03", {
        scrollTrigger: {
          trigger:".clean-sect",
          start:'top center',
          toggleActions: "play none none none"
        },
        opacity: 0,
        duration: 1,
        delay:2.6
      });
      //infomation-sect 스크롤
      ScrollTrigger.create({
        trigger:'.infomation-sect',
        start: 'top center',
        end: 99999,
        onEnter: () => {video02Player.pause()},
      });
    }, 
    
    // mobile
    "(max-width: 799px)": function() {
      // Any ScrollTriggers created inside these functions are segregated and get
      // reverted/killed when the media query doesn't match anymore. 
      //infomation-sect 스크롤
      // gsap.to(".review-sect", {
      //   scrollTrigger: {
      //     trigger:".review-sect",
      //     start:'top center',
      //     onEnter: () => {reviewSwiper.autoplay.start()},
      //     toggleActions: "play none none none"
      //   }
      // });
      reasonList.forEach((reason,index) => {
        gsap.fromTo(reason, 
        {
          y: 50,
          opacity:0,
        },
        {
          scrollTrigger: {
            trigger:reason,
            start:'top bottom',
            end: () => `+=${reason.clientHeight}`,
            onEnter:() => {
              if(video02Player == ''){
                video02Player = new Vimeo.Player('player2', options02);
              } else{
                video02Player.pause()
              }
            },
            onEnterBack: () => {video02Player.pause()},
            onLeave:()=>{video02Player.play()},
            //markers:true
          },
          y: 0,
          opacity:1,
          duration:.6,
          ease:'ease',
          delay:`${index * .2}`
        });
      });
      ScrollTrigger.create({
        trigger:'.infomation-sect',
        start: 'top 20%',
        end: 'bottom 80%',
        onEnter: () => {video02Player.pause()},
        onEnterBack: () =>{video02Player.play()},
        onLeave:()=>{video02Player.play()},
        onLeaveBack:()=>{video02Player.play()},
        //markers:true,
      });
    }, 
    
    // all 
    "all": function() {
      // ScrollTriggers created here aren't associated with a particular media query,
      // so they persist.
      
    }
    
  });

}
/* 
window.addEventListener('DOMContentLoaded', (event) => {
  var textWrapper = document.querySelector('.ml3');
  textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
  anime.timeline({loop: false})
  .add({
    targets: '.ml3 .letter',
    opacity: [0,1],
    easing: "easeInOutQuad",
    duration: 600,
    delay: (el, i) => 150 * (i+1)
  }).add({
    targets: '.ml3',
    opacity: 0,
    duration: 1000,
    easing: "easeOutExpo",
    delay: 1000
  });
  const mainIntro = document.querySelector('.main-visual-intro');
  const textAnims = document.querySelectorAll('.anim_txt');
  var step;
  for(step = 0; step < textAnims.length; step++){
    textAnims[step].classList.add('active');
  }
  setTimeout(()=>{
    mainIntro.classList.add('hide-onload');
  },3000);

});
 */

const parallax = document.querySelectorAll('.parallax');
parallax.forEach((parallax,index) => {
  parallax.bg = parallax.querySelector(".parallax-img");

  if (index) {
    parallax.bg.style.backgroundPosition = `50% ${innerHeight / 2}px`;

    gsap.to(parallax.bg, {
      backgroundPosition: `50% ${innerHeight / 4}px`,
      opacity:0,
      ease: "none",
      scrollTrigger: {
        trigger: parallax,
        scrub: true
      }
    });
  } 
  
  // the first image should be positioned against the top. Use px on the animating part to work with GSAP. 
  else {
    parallax.bg.style.backgroundPosition = "50% 0px"; 

    gsap.to(parallax.bg, {
      backgroundPosition: `50% ${innerHeight / 4}px`,
      opacity:0,
      ease: "none",
      duration:1.25,
      scrollTrigger: {
        trigger: parallax,
        start: "top top", 
        end: "bottom top",
        scrub: true
      }
    });
  }
  
});

const subjectItem = document.querySelectorAll('.subject-list-item');
subjectItem.forEach((elem,index) => {
  //elem.bg = elem.querySelector(".subject-item-bg");
  const getDelay = elem.getAttribute('data-gs-delay');
  const gsDelay = (getDelay / 1000) | 0;
  gsap.fromTo(elem, {y:100,autoAlpha:0},{
    y:0,
    autoAlpha:1.5,
    ease: "ease",
    scrollTrigger: {
      trigger: elem,
      start:'top 80%',
      toggleActions:'play none none none',
      overwrite: "auto",
      delay: gsDelay
    }
  });
});


const interiorView = new Swiper('.interiorView', {
  // Optional parameters
  loop: true,
  effect:'fade',
  speed:800,
  autoplay: {
		delay: 5000,
	},
  // pagination
  pagination: {
		el: '.interiorThumb',
		type: 'bullets',
		clickable: true,
	},
  // Navigation arrows
  navigation: {
      nextEl: '.ctrls2.next',
      prevEl: '.ctrls2.prev',
  },
});

/* 
  서브페이지 애니메이션 
*/

// const animateFrom = (elem, direction) => {
//   direction = direction | 1;
  
//   var x = 0,
//       y = direction * 100;

//   if(elem.classList.contains("gs_reveal_fromLeft")) {
//     x = -100;
//     y = 0;
//   } else if(elem.classList.contains("gs_reveal_fromRight")) {
//     x = 100;
//     y = 0;
//   } 
//   const getDelay = elem.getAttribute('data-gs-delay');
//   const gsDelay = (getDelay / 1000) | 0;
//   gsap.fromTo(elem, {x: x, y: y,z: -100, autoAlpha: 0 }, {
//     duration: 1.25, 
//     x: 0,
//     y: 0,
//     z: 0,
//     autoAlpha: 1, 
//     ease: "expo", 
//     overwrite: "auto",
//     delay: gsDelay
//   });
// }

const hide = (elem) => {
  gsap.set(elem, {autoAlpha: 0});
}

gsap.utils.toArray(".gs_reveal").forEach(function(elem,index) {

  hide(elem); // assure that the element is hidden when scrolled into view
  const getDelay = elem.getAttribute('data-gs-delay');

  var x = 0,
      y = 60,
      z = -100;
  
  if(elem.classList.contains('sm_reveal')){
    y = 12,
    z = -10
  } else if(elem.classList.contains("reveal_fromRight")) {
    x = 100;
    y = 0;
    z = 10;
  } else if(elem.classList.contains("reveal_fromLeft")) {
    x = -100;
    y = 0;
    z = 10;
  }
  gsap.fromTo(elem,{x: x, y: y,z: z, autoAlpha: 0 },{
    scrollTrigger:{
      trigger: elem.parentNode,
      start:'top 75%',
      toggleActions: 'play none none none',
      //markers:true
    },
    duration: 1.5, 
    x: 0,
    y: 0,
    z: 0,
    autoAlpha: 1, 
    ease: "expo", 
    overwrite: "auto",
    delay: getDelay*0.001
  });
  // ScrollTrigger.create({
  //   trigger: elem,
  //   start:'top 75%',
  //   //end:'top 10%',
  //   onEnter: function() { animateFrom(elem) }, 
  //   onEnterBack: function() { animateFrom(elem, -1) },
  //   onLeave: function() { hide(elem) },
  //   // assure that the element is hidden when scrolled into view
  // });
});


// zoomIn 애니메이션



gsap.utils.toArray(".zoomIn").forEach(function(elem) {
  const tg = elem.querySelector('.zoomInImg');
  hide(tg); // assure that the element is hidden when scrolled into view
  const getDelay = elem.getAttribute('data-gs-delay');
  const gsDelay = (getDelay / 1000) | 0;

  gsap.fromTo(tg, {scale:1.2, autoAlpha: 0 }, {
    scrollTrigger:{
      trigger: elem,
      start:'top 75%',
      toggleActions: 'play none none none'
    },
    duration: 2.5, 
    scale: 1,
    autoAlpha: 1, 
    ease: "expo",
    overwrite: "auto",
    delay:gsDelay
  });

});

